<template>
    <v-btn 
        outlined
        class="light-blue-button"
        color="primary darken-1"
        :disabled="disableResendWelcome"
        @click="resendWelcomeEmail()">
        Resend Welcome Email
    </v-btn>
</template>

<script>  
    import axios from "axios"
    import Cookie from 'js-cookie'
    import appUrls from '../../helpers/environment'

    export default {
        name: 'resendWelcomeEmailButton',

        props: {
            userData: Object,
            userFeedback: Function
        },

        data () {
            return {
                disableResendWelcome: false
            }
        },
        
        methods: {
            resendWelcomeEmail: async function () {
                try {
                    const resend_email = await axios.put(`${appUrls.api}/api/admin/resend_welcome/${this.userData.user_id}/welcome_email`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    })
                
                    if ( resend_email.data.outcome ) {                        
                        this.$feedback.success( resend_email.data.message );
                        this.disableResendWelcome = resend_email.data.reset
                    }
                } catch ( error ) {
                    console.log(error);
                }
            }
        }
    }
</script>

<style scoped>
    .light-blue-button {
        background-color: #eef7f8;
    }
</style>


// WEBPACK FOOTER //
// src/components/shared/resendWelcome.vue